import createPdf, { noPadding } from '../createPdf';

import { flatMap, get } from 'lodash';

const cellMargin = [4, 2, 4, 2];

const createTitledCell = (title, value, extra) => ({
  margin: cellMargin,
  layout: {
    defaultBorder: false,
    ...noPadding,
  },
  table: {
    widths: ['100%'],
    body: [
      [
        {
          text: title || ' ',
          alignment: 'center',
          fontSize: 8,
          italics: true,
          ...extra,
        },
      ],
      [
        {
          text: value || ' ',
          fontSize: 14,
          alignment: 'center',
          italics: true,
          bold: true,
        },
      ],
    ],
  },
});

const createHalfCell = (left, right) => ({
  layout: {
    defaultBorder: false,
    ...noPadding,
    vLineWidth: () => 2,
  },
  table: {
    widths: ['50%', '50%'],
    body: [
      [
        { ...left, border: [false, false, true, false] },
        { ...right /*, border: [true, false, false, false]*/ },
      ],
    ],
  },
});

const createTeamsCell = athlete => {
  const teams = get(athlete, 'teams', []);

  return {
    margin: cellMargin,
    fontSize: 24,
    text: teams.length ? teams.join(', ') : ' ',
    color: 'red',
    alignment: 'center',
    bold: true,
  };
};

const createNameCell = athlete => {
  const name = get(athlete, 'name', '');

  return {
    margin: cellMargin,
    maxHeight: 1.5 * 24,
    text: name.length ? name : ' ',
    alignment: 'center',
    bold: true,
  };
};
/*
const createCompetitionCell = athlete => ({
  margin: cellMargin,
  fontSize: 8,
  text: '20- ja 23-vuotiaiden SM-kilpailut',
  alignment: 'center',
  bold: true,
});
*/
const createBipCell = athlete => ({
  margin: cellMargin,
  fontSize: 8,
  text: 'BIB:',
  italics: true,
});

const createLotCell = athlete =>
  createTitledCell('LOT:', athlete.lotNumber || '___');

const createCategoryCell = athlete =>
  createTitledCell(
    'CATEGORY:',
    [athlete.category || '___', athlete.group || '__'].join(' '),
  );

const createDateOfBirthCell = athlete =>
  createTitledCell('DATE OF BIRTH:', athlete.dateOfBirth || ' ');

const createBodyweightCell = athlete =>
  createTitledCell('B.WEIGHT:', athlete.bodyweight || ' ');

const createEntryTotalCell = athlete =>
  createTitledCell('ENTRY TOTAL:', athlete.entryTotal || ' ', { fontSize: 7 });

const createSignatureCell = athlete => createTitledCell('SIGNATURE:', ' ');

const createHeaderRows = athlete => [
  [
    { ...createBipCell(athlete), rowSpan: 4 /* 5 */ },
    { ...createTeamsCell(athlete), colSpan: 2 },
    {},
  ],
  [{}, { ...createNameCell(athlete), colSpan: 2 }, {}],
  //[{}, { ...createCompetitionCell(athlete), colSpan: 2 }, {}],
  [
    {},
    createHalfCell(createLotCell(athlete), createCategoryCell(athlete)),
    createDateOfBirthCell(athlete),
  ],
  [
    {},
    createHalfCell(
      createBodyweightCell(athlete),
      createEntryTotalCell(athlete),
    ),
    createSignatureCell(),
  ],
];

const createLiftTitleRow = lift => [
  {
    colSpan: 3,
    margin: cellMargin,
    fontSize: 20,
    text: lift, //.toUpperCase().replace('AND', 'and'),
    alignment: 'center',
    bold: true,
    fillColor: 'black',
    color: 'white',
  },
  {},
  {},
];

const createAttemptHeaderCell = number => ({
  margin: cellMargin,
  text: `${number}. Attempt`,
  alignment: 'center',
  bold: true,
  fontSize: 10,
});

const createDeclarationCell = title => ({
  layout: {
    defaultBorder: false,
    ...noPadding,
    vLineWidth: () => 0,
    hLineWidth: () => 1,
    hLineColor: () => '#DDD',
  },
  table: {
    widths: ['100%'],
    heights: [40, 40],
    body: [
      [
        {
          margin: cellMargin,
          border: [false, false, false, true],
          fontSize: 8,
          text: title,
          italics: true,
        },
      ],
      [
        {
          margin: cellMargin,
          fontSize: 8,
          text: 'Signature:',
          italics: true,
        },
      ],
    ],
  },
});

const createLiftRows = lift => [
  createLiftTitleRow(lift),
  [1, 2, 3].map(createAttemptHeaderCell),
  [
    {
      border: [true, true, true, false],
      margin: cellMargin,
      fontSize: 8,
      text: 'DECLARED WEIGHT AT THE WEIGH-IN:',
      italics: true,
      /*
      table: {
        widths: ['*'],
        heights: [80],
        layout: {
          ...noPadding,
          vLineWidth: () => 0,
          hLineWidth: i => (i === 1 ? 1 : 0),
          hLineColor: '#DDD',
        },
        body: [
          [
            {
              margin: cellMargin,
              fontSize: 8,
              text: 'DECLARED WEIGHT AT THE WEIGH-IN:',
              italics: true,
            },
          ],
        ],
      },
      */
    },
    createDeclarationCell('Automatic increment:'),
    createDeclarationCell('Automatic increment:'),
  ],
  [
    {
      margin: cellMargin,
      border: [true, false, true, true],
      fontSize: 8,
      text: 'SIGNATURE:',
      italics: true,
    },
    //createDeclarationCell('Declared weight at the weigh-in:'),
    createDeclarationCell('Declared weight:'),
    createDeclarationCell('Declared weight:'),
  ],
  [
    createDeclarationCell('1st change:'),
    createDeclarationCell('1st change:'),
    createDeclarationCell('1st change:'),
  ],
  [
    createDeclarationCell('2nd change:'),
    createDeclarationCell('2nd change:'),
    createDeclarationCell('2nd change:'),
  ],
];

const createPageContent = (athlete, lift) => ({
  layout: {
    ...noPadding,
    vLineWidth: () => 2,
    hLineWidth: () => 2,
  },
  table: {
    widths: ['33.33%', '33.33%', '33.33%'],
    body: [...createHeaderRows(athlete), ...createLiftRows(lift)],
  },
});

const createAthletesCardContent = athlete => [
  {
    columns: [
      {
        ...createPageContent(athlete, 'S N A T C H'),
        width: '50%',
      },
      {
        ...createPageContent(athlete, 'C L E A N and J E R K'),
        width: '50%',
      },
    ],
  },
];

const createAthletesCardsPdf = (athletes, meta) => {
  // TODO: Add support for cover pages with session names!
  const content = flatMap(athletes, createAthletesCardContent).map(
    (content, i) => (i ? { ...content, pageBreak: 'before' } : content),
  );
  const docDefinition = {
    info: {
      title: "Athletes' Cards - Nosturi",
      creator: `Nosturi v${process.env.REACT_APP_VERSION}`,
    },
    pageSize: 'A4',
    pageOrientation: 'landscape',
    pageMargins: [40, 40, 40, 40],
    defaultStyle: {
      columnGap: 40,
      fontSize: 12,
    },
    content,
  };

  return createPdf(docDefinition);
};

export default createAthletesCardsPdf;



// WEBPACK FOOTER //
// ./src/pages/Home/athletesCards/createAthletesCardsPdf.js